import { AxiosPromise } from 'axios';

import { ICollaboratorChange } from '~/components/CollaboratorModal';
import { ICollaborator } from '~/models/Collaborator';

import api from './api';

export interface ICollaboratorEdit {
  collaborator: ICollaborator;
  dec_password: string;
}

const CollaboratorsService = {
  getCollaborators(): AxiosPromise<ICollaborator[]> {
    return api.get('collaborator');
  },

  getOnlyCollaborator(id: number): AxiosPromise<ICollaboratorEdit> {
    return api.get(`collaborator/${id}`);
  },

  updateCollaborator(
    id: number,
    data: ICollaboratorChange,
  ): AxiosPromise<ICollaboratorEdit> {
    return api.put(`collaborator/${id}`, data);
  },

  addCollaborator(data: ICollaboratorChange): AxiosPromise<ICollaboratorEdit> {
    return api.post(`auth/signup`, { ...data, role: 'collaborator' });
  },

  desactiveCollaborator(
    id: number,
    state: boolean,
    password: string,
  ): AxiosPromise<ICollaboratorEdit> {
    return api.put(`collaborator/${id}`, { status: state, password });
  },

  removeCollaborator(id: number): AxiosPromise<any> {
    return api.delete(`users/${id}`);
  },
};

export default CollaboratorsService;
